import { ICONS, type IconName } from './icons.ts';
import './Icon.css';

export type { IconName } from './icons.ts';

/**
 * One icon from the line set. Decorative by default (`aria-hidden`); pass `label` when the icon
 * alone carries meaning. Icon-only buttons put their `aria-label` on the button instead.
 */
export function Icon({
  name,
  size = 'm',
  filled = false,
  bold = false,
  label,
  className,
}: {
  name: IconName;
  size?: 's' | 'm' | 'l' | 'xl';
  /** Only the favourite heart and the rating star when on (DESIGN.md §7). */
  filled?: boolean;
  bold?: boolean;
  label?: string;
  className?: string;
}) {
  const classes = ['ic'];
  if (size !== 'm') classes.push(`ic--${size}`);
  if (filled) classes.push('ic--fill');
  if (bold) classes.push('ic--bold');
  if (className) classes.push(className);
  return (
    <svg
      className={classes.join(' ')}
      viewBox="0 0 24 24"
      {...(label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true })}
    >
      <path d={ICONS[name]} />
    </svg>
  );
}
